import React from 'react';
import { StyledBalance } from './styles';
import { EBalancesTheme } from 'utils/enums';
import { formattingNumber } from 'utils/index';
import { NumberConfig } from 'utils/types';

interface IBalanceProps {
  balanceFontSize?: number;
  balanceWeight?: number;
  balanceColor?: string;
  balanceTheme?: EBalancesTheme;
  image?: string;
  amount?: number | string;
  balanceQuantityFormat?: NumberConfig;
}

interface IBalanceFormatting {
  multiplier?: number;
  abbreviateWithDecimals?: boolean;
}

export const Balance = ({
  balanceFontSize,
  balanceWeight,
  balanceColor,
  image = '',
  amount = 0,
  balanceTheme = EBalancesTheme.DEFAULT,
  balanceQuantityFormat = {
    billionShorthand: false,
    fractionalSeparator: '.',
    milSeparator: '',
    millionShorthand: false,
    thousandShorthand: false,
  },
}: IBalanceProps) => {
  const balanceFormattingMap: Partial<
    Record<EBalancesTheme, IBalanceFormatting>
  > = {
    [EBalancesTheme.BAGELCODE]: {
      abbreviateWithDecimals: Number(amount) >= 1000,
    },
    [EBalancesTheme.ME2ON]: {
      abbreviateWithDecimals: true,
    },
  };

  const balanceFormatting = balanceFormattingMap[balanceTheme];

  return (
    <StyledBalance
      balanceFontSize={balanceFontSize}
      balanceWeight={balanceWeight}
      balanceColor={balanceColor}
      className={balanceTheme}
    >
      {image && (
        <div className="balance-image">
          <img className="image" src={image} alt="balance-img" />
        </div>
      )}
      {amount && (
        <div className="balance-amount">
          {formattingNumber({
            number: amount,
            config: balanceQuantityFormat,
            ...balanceFormatting,
          })}
        </div>
      )}
    </StyledBalance>
  );
};
